/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Cmstools_Restore_Confirm1Inputs */

const vi_cmstools_restore_confirm1 = /** @type {(inputs: Cmstools_Restore_Confirm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nạp lại bản đã đăng "${i?.title}" vào bản đang soạn? Website chưa đổi cho tới khi bấm Đăng.`)
};

/**

* @param {Cmstools_Restore_Confirm1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_restore_confirm1 = /** @type {((inputs: Cmstools_Restore_Confirm1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Restore_Confirm1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_restore_confirm1(inputs)
});
export { cmstools_restore_confirm1 as "cmsTools_restore_confirm" }